import { type Tag } from "../components/Tag";

export enum EventTag {
  OFFICIAL = "Official",
  FEATURE = "Feature",
}

export const EventTagSet: Record<EventTag, Tag> = {
  [EventTag.OFFICIAL]: {
    id: EventTag.OFFICIAL,
    label: EventTag.OFFICIAL,
    color: "#FF0000",
  },
  [EventTag.FEATURE]: {
    id: EventTag.FEATURE,
    label: EventTag.FEATURE,
    color: "#00FF00",
  },
};
